// Sede.jsx (parent page)
import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";
import SedeList from "../components/Sede/SedeList";
import NewSedeModal from "../components/Sede/NewSedeModal";
import axios from "axios";
import { getAuthHeaders } from "../utils/auth";
import { buildSedesWithSubsUrl } from "../constants"; // <- use the helper

class Sede extends Component {
  state = { sedes: [], loading: false, error: "" };

  componentDidMount() {
    this.resetState();
  }

  getSedes = async () => {
    this.setState({ loading: true, error: "" });
    const url = buildSedesWithSubsUrl();
    try {
      const headers = getAuthHeaders();

      const res = await axios.get(url, { headers });


      if (Array.isArray(res.data)) {
        this.setState({ sedes: res.data });
      } else {
        console.warn("⚠️ Expected array, got:", typeof res.data, res.data);
        this.setState({
          sedes: [],
          error:
            "La API no devolvió una lista. Verifica la URL base o el endpoint.",
        });
      }
    } catch (err) {
      console.error("❌ Error fetching sedes:", err);
      this.setState({ sedes: [], error: "No se pudieron cargar las sedes." });
    } finally {
      this.setState({ loading: false });
    }
  };

  resetState = () => this.getSedes();

  render() {
    const { sedes, loading, error } = this.state;

    return (
      <Container style={{ marginTop: "20px" }}>
        <h1>Value Streams</h1>
        <Row>
          <Col>
            <SedeList
              sedes={sedes}
              loading={loading}
              error={error}
              itemsPerPage={8}
              resetState={this.resetState}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <NewSedeModal create={true} resetState={this.resetState} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Sede;